import { z } from "zod";

import { Price } from "@/common/models/price";

export const packageCardPropsSchema = z.object({
  name: z.string().min(3),
  category: z.string().min(3),
  coverImageUrl: z.string().min(3),
  price: Price.schema,
  bloodTests: z.array(z.string().min(2)).min(1),
  description: z.string().min(3),
  detailsUrl: z.string(),
});
